
interface HoveredMarkerOptions {
  colorScheme?: 'dark' | 'light';
}

export const hoveredMarker = ({ colorScheme }: HoveredMarkerOptions) => {
  const markerFill = colorScheme === 'dark' ? '#A8141A' : '#F3676C';
  const innerCircleFill = colorScheme === 'dark' ? '#640C0F' : '#A8141A';

  const svg = `
    <svg width="44" height="45" viewBox="0 0 38 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <style type="text/css">
          <![CDATA[
            @import url('https://fonts.googleapis.com/css2?family=Merriweather+Sans:ital,wght@0,300..800;1,300..800&display=swap');
          ]]>
        </style>
      </defs>
      <g transform="translate(7.5, 6)">
        <path d="M37.6693 19.3346C37.6693 33.3346 19.0026 47.3346 19.0026 47.3346C19.0026 47.3346 0.335938 33.3346 0.335938 19.3346C0.335938 14.3839 2.3026 9.63599 5.80328 6.13531C9.30396 2.63463 14.0519 0.667969 19.0026 0.667969C23.9533 0.667969 28.7013 2.63463 32.2019 6.13531C35.7026 9.63599 37.6693 14.3839 37.6693 19.3346Z" fill="${markerFill}"/>
        <circle cx="19" cy="19" r="9" fill="${innerCircleFill}" />
      </g>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};
